import { Avatar } from 'antd'
import { MyTheme } from 'Components/common/Theme'
import { appConfig } from 'config'
import React from 'react'
import styled from 'styled-components'

const MerchantLogo = `${appConfig.publicAssetEndpoint}/etc/merchant.png`

type Props = {
  size?: number
  logo?: string
}

const Merchant = (props: Props) => {
  const { size = 25, logo = '' } = props
  const src = appConfig.assetCdnEndpoint + logo
  return <MerchantAvatar src={logo ? src : MerchantLogo} size={size}></MerchantAvatar>
}

const MerchantAvatar = styled(Avatar)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.white};
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

export default Merchant
